<div class="row">
	<div class="col-xs-2 col-sm-4">
		<button type="button" id="js-minus" class="btn btn-white">
			<i class="fa fa-minus"></i>
		</button>
	</div>
	<div class="col-xs-8 col-sm-4">
		<div class="input-group">
			<span id="js-input-sign" class="input-group-addon">+</span>
			<input id="js-relative-value-input" class="form-control full-width"
				type="number" min="-100" name="relativeValue" value="0">
			<span class="input-group-addon">%</span>
		</div>
	</div>
	<div class="col-xs-2 col-sm-4">
		<button type="button" id="js-plus" class="btn btn-white pull-right">
			<i class="fa fa-plus"></i>
		</button>
	</div>
</div>
